import * as CommonTypes from "../types/common.types";
import http from "./http-common";

class AdminServiceClass {
    private token: string | undefined;
    private config: { headers: { Authorization: string | undefined } };
    private super: string = '/superowner'
    private agency: string = '/agency'
    private seller: string = '/seller'
    private admin: string = '/admin'
    private passenger: string = '/passenger'
    private tours: string = '/tours'
    private trips: string = '/trips'
    private guider: string = '/guider'
    private driver: string = '/driver'
    private reservation: string = '/reservation'
    private payment: string = '/payments'
    private zone: string = '/zone'
    private sales: string = '/sales'
    private car: string = '/car'
    private cost: string = '/cost'
    private openai: string = '/openai'
    private passenger_authorizations: string = '/passenger_authorizations'

    constructor(token?: string) {
        this.token = token;
        this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }
    
    setToken(token: string) {
      this.token = token;
      this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }

    login(data: CommonTypes.DefaultLogin) {
      return http.post(this.super + '/login', data)
    }

    createTour(data: Partial<CommonTypes.Tour>) {
      return http.post(this.tours + '/create', data, this.config)
    }

    createTrip(data: Partial<CommonTypes.Trip>) {
      return http.post(this.trips, data, this.config)
    }

    editTrip(trip_id: string, data: CommonTypes.Trip) {
      return http.put(this.trips + `/editTrip/${trip_id}`, data, this.config)
    }

    deleteTrip(trip_id: string) {
      return http.delete(this.trips + `/delete/${trip_id}`, this.config)
    }

    me() {
      return http.get(this.super + '/me', this.config)
    }

    getTour(id: string) {
      return http.get(this.tours + `/tour/${id}`, this.config)
    }

    editTour(data: CommonTypes.EditTour) {
      return http.put(this.tours + `/edit`, data, this.config)
    }

    deleteTour(id: string) {
      return http.delete(this.tours + `/delete/${id}`, this.config)
    }

    getPassengerPlan(id: string) {
      return http.get(this.passenger + `/passenger-plan?passenger_id=${id}`, this.config)
    }

    helthByDay(seller_id: string, day: Date, endDay?: Date) {
      return http.post(this.seller + '/healthByDay', {seller_id, day, endDay}, this.config)
    }

    deleteReservation(id: string) {
      return http.delete(this.reservation + `/delete/${id}`, this.config)
    }

    traspass(data: CommonTypes.TraspassReservations) {
      return http.post(this.reservation + '/traspass', data, this.config)
    }

    listTraspass() {
      return http.get(this.reservation + '/listTraspass', this.config)
    }

    getTraspass(agency_id: string) {
      return http.get(this.reservation + `/traspass/${agency_id}`, this.config)
    }

    // agencies 
    createAgency(data: Partial<CommonTypes.Agency>) {
      return http.post(this.agency + '/register', data, this.config)
    }

    editAgency(data: Partial<CommonTypes.Agency>) {
      return http.put(this.agency + '/edit', data, this.config)
    }

    deleteAgency(id: string) {
      return http.delete(this.agency + `/delete/${id}`, this.config)
    }

    editAgencyInfo(data: FormData) {
      return http.put(this.agency + `/edit/info`, data , {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    agencyMe() {
      return http.get(this.agency + '/me', this.config)
    }

    // sellers
    createSeller(data: Partial<CommonTypes.Seller>) {
      return http.post(this.seller + '/register', data, this.config)
    }

    editSeller(data: Partial<CommonTypes.Seller>) {
      return http.put(this.seller + '/edit', data, this.config)
    }

    deleteSeller(id: string) {
      return http.delete(this.seller + `/delete/${id}`, this.config)
    }

    createPassenger(data: Partial<CommonTypes.Passenger>) {
      return http.post(this.passenger + '/create', data, this.config)
    }

    editPassenger(data: Partial<CommonTypes.Passenger>) {
      return http.put(this.passenger + '/edit/admin', data, this.config)
    }

    deletePassenger(id: string) {
      return http.delete(this.passenger + `/delete/${id}`, this.config)
    }

    createAdmin(data: Partial<CommonTypes.Admin>) {
      return http.post(this.admin + '/register', data, this.config)
    }

    editAdmin(data: Partial<CommonTypes.Admin>) {
      return http.put(this.admin + '/edit', data, this.config)
    }

    deleteAdmin(id: string) {
      return http.delete(this.admin + `/delete/${id}`, this.config)
    }

    createGuider(data: Partial<CommonTypes.Guider>) {
      return http.post(this.guider + '/create', data, this.config)
    }

    editGuider(data: Partial<CommonTypes.Guider>) {
      return http.put(this.guider + '/edit', data, this.config)
    }

    deleteGuider(id: string) {
      return http.delete(this.guider + `/delete/${id}`, this.config)
    }

    createDriver(data: Partial<CommonTypes.Driver>) {
      return http.post(this.driver + '/create', data, this.config)
    }

    editDriver(data: Partial<CommonTypes.Driver>) {
      return http.put(this.driver + '/edit', data, this.config)
    }

    deleteDriver(id: string) {
      return http.delete(this.driver + `/delete/${id}`, this.config)
    }

    listToursReservationsPassengers(date: Date) {
      return http.post(this.tours + '/listToursReservationsPassengers', {date}, this.config)
    }

    listToursTrips(date: string) {
      return http.post(this.tours + '/listToursTripsPassengers', {date}, this.config)
    }

    // trips
    listEarnings(day: Date, endDay?: Date) {
      return http.post(this.trips + '/list/earnings', {day, endDay}, this.config)
    }

    listToursAssigned(date: string) {
      return http.post(this.tours + '/listToursTripsAssigned', {date}, this.config)
    }
    
    listTripsByDay(date: Date, tour_id: string) {
      return http.post(this.trips + '/listTripsByDay', {date, tour_id}, this.config)
    }

    listTripsByDayTraspass(date: Date, tour_id: string) {
      return http.post(this.trips + '/listTripsByDayTraspass', {date, tour_id}, this.config)
    }

    listTripsByDayReservations(date: Date) {
      return http.post(this.trips + '/listTripsByDayReservations', {date}, this.config)
    }

    updateCosts(costs: CommonTypes.TripCost[], trip_id: string) {
      return http.put(this.trips + '/costs', {costs, trip_id}, this.config)
    }

    addPassengers(trip_id: string, passengers: CommonTypes.Passenger[]) {
      return http.post(this.trips + '/addPassengers', {trip_id, passengers}, this.config)
    }

    // reservations

    updatePassStatus(status: boolean, reservation_id: string) {
      return http.put(this.reservation + '/passStatus', {status, reservation_id}, this.config)
    }

    updateArriveStatus(status: boolean, reservation_id: string) {
      return http.put(this.reservation + '/arriveStatus', {status, reservation_id}, this.config)
    }

    traspassAddPassengers(trip_id: string, agency: string, passengers: CommonTypes.Passenger[]) {
      return http.post(this.trips + '/traspass/addPassengers', {trip_id, agency, passengers}, this.config)
    }

    traspassCreateToken(trip_id: string, agency: string) {
      return http.post(this.trips + '/traspass/createToken', {trip_id, agency}, this.config)
    }

    traspassAddPassengersToken(token_id: string, passengers: CommonTypes.Passenger[]) {
      return http.post(this.trips + '/traspass/addPassengersToken', {token_id, passengers})
    }

    assignTrip(reservation_ids: string[], trip_id: string, traspass_price?: number) {
      return http.post(this.reservation + '/assignTrip', {reservation_ids, trip_id, traspass_price}, this.config)
    }

    unassignTrip(reservation_id: string) {
      return http.put(this.reservation + '/unassignTrip', {reservation_id}, this.config)
    }

    // sales 
    listSales(seller_id: string) {
      return http.post(this.seller + '/listSales', {seller_id}, this.config)
    }

    updateSales(authorized: boolean, amount: number, sale_id: string) {
      return http.put(this.seller + '/updateSales', {authorized, amount, sale_id}, this.config)
    }

    deleteSale(sale_id: string) {
      return http.delete(this.seller + `/deleteSale/${sale_id}`, this.config)
    }

    listSalesByDay(start_date: Date, seller_id: string, end_date?: Date) {
      return http.post(this.sales + '/list-per-day', { start_date, seller_id, end_date }, this.config)
    }

    getTrip(trip_id: string) {
      return http.get(this.trips + `/trip?trip_id=${trip_id}`, this.config)
    }

    closeTrip(trip_id: string) {
      return http.put(this.trips + '/close', { trip_id }, this.config)
    }

    listAdmins() {
      return http.get(this.admin + '/list', this.config)
    }

    listSellers() {
      return http.get(this.seller + '/list', this.config)
    }

    listAgencies() {
      return http.get(this.agency + '/list', this.config)
    }

    listPassengers() {
      return http.get(this.passenger, this.config)
    }

    listGuiders() {
      return http.get(this.guider, this.config)
    }

    listDrivers() {
      return http.get(this.driver, this.config)
    }

    // reservations

    getReservation(reservation_id: string) {
      return http.get(this.reservation + `/reservation/${reservation_id}`, this.config)
    }

    editReservation(reservation_id: string, data: CommonTypes.Reservation) {
      return http.put(this.reservation + `/edit/${reservation_id}`, data, this.config)
    }

    editPassengerReservation(reservation_id: string, data: Partial<CommonTypes.ReservationPassenger>) {
      return http.put(this.reservation + `/editPassenger/${reservation_id}`, data, this.config)
    }

    // payments
    registerPayment(data: FormData) {
      return http.post(this.payment + '/add', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    registerReservationPayment(data: FormData) {
      return http.post(this.payment + '/add-reservation', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listPayments(agency_id: string, day: Date, endDay?: Date) {
      return http.post(this.payment + '/list', {agency_id, day, endDay}, this.config)
    }

    deletePayment(payment_id: string) {
      return http.delete(this.payment + `/delete/${payment_id}`, this.config)
    }

    editPayment(payment_id: string, data: FormData) {
      return http.put(this.payment + `/edit/${payment_id}`, data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    createReservationPayment(data: FormData) {
      return http.post(this.payment + '/create-reservation-payment', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listReservationPayments(reservation_id: string) {
      return http.get(this.payment + `/list-reservation-payments/${reservation_id}`, this.config)
    }

    editReservationPayment(payment_reservation_id: string, data: FormData) {
      return http.put(this.payment + `/edit-reservation-payment/${payment_reservation_id}`, data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    deleteReservationPayment(payment_reservation_id: string) {
      return http.delete(this.payment + `/delete-reservation-payment/${payment_reservation_id}`, this.config)
    }

    authorizeReservationPayment(payment_reservation_id: string) {
      return http.put(this.payment + `/authorize-reservation-payment/${payment_reservation_id}`, {}, this.config)
    }

    // tour info

    getTourInfo(data: Partial<CommonTypes.TourInfo>) {
      return http.post(this.tours + '/info', data, this.config)
    }
    
    handleTourInfo(data: FormData) {
      return http.put(this.tours + '/handle/info', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }
    
    // blogs

    postBlog(data: FormData) {
      return http.post(this.tours + '/blog', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    editBlog(data: FormData) {
      return http.put(this.tours + '/blog', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listBlogsTour(tour_id: string) {
      return http.get(this.tours + `/blog/${tour_id}`, this.config)
    }
    
    deleteBlog(blog_id: string) {
      return http.delete(this.tours + `/blog/${blog_id}`, this.config)
    }

    // zones
    registerZone(data: FormData) {
      return http.post(this.zone + '/register', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    editZone(data: FormData) {
      return http.put(this.zone + '/edit', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    deleteZone(id: string) {
      return http.delete(this.zone + `/delete/${id}`, this.config)
    }

    listZones() {
      return http.get(this.zone + '/list', this.config)
    }

    assignZone(tour_id: string, zone_id: string) {
      return http.post(this.zone + '/assign', { tour_id, zone_id }, this.config)
    }

    // cars
    registerCar(data: Partial<CommonTypes.Car>) {
      return http.post(this.car + '/register', data, this.config)
    }

    listCars() {
      return http.get(this.car + '/list', this.config)
    }

    editCar(data: Partial<CommonTypes.Car>) {
      return http.put(this.car + '/edit', data, this.config)
    }

    deleteCar(id: string) {
      return http.delete(this.car + `/delete/${id}`, this.config)
    }

    // costs
    listCosts() {
      return http.get(this.cost + '/', this.config)
    }

    createCost(data: Partial<CommonTypes.Cost>) {
      return http.post(this.cost + '/', data, this.config)
    }

    editCost(data: Partial<CommonTypes.Cost>) {
      return http.put(this.cost + '/', data, this.config)
    }
    
    deleteCost(id: string) {
      return http.delete(this.cost + `/delete/${id}`, this.config)
    }

    createDailyCost(data: Partial<CommonTypes.DailyCost>) {
      return http.post(this.cost + '/daily', data, this.config)
    }

    listDailyCosts(day: Date) {
      return http.post(this.cost + '/daily/list', { day }, this.config)
    }

    editDailyCost(id: string, data: Partial<CommonTypes.DailyCost>) {
      return http.put(this.cost + `/daily/edit/${id}`, data, this.config)
    }
    
    deleteDailyCost(id: string) {
      return http.delete(this.cost + `/daily/delete/${id}`, this.config)
    }

    getCostsByTripRange(cost: string, day: Date, endDay?: Date) {
      return http.post(this.cost + `/list/cost/trips/${cost}`, {day, endDay}, this.config)
    }

    // openai
    extractPassengerData(inputText: string) {
      return http.post(this.openai + '/extract-passenger', { text: inputText }, this.config)
    }

    // authorizations
    createPassengerAuthorization(data: CommonTypes.PassengerAuthorization) {
      return http.post(this.passenger_authorizations + '/create', data, this.config)
    }

    getPassengerAuthorizations(startDate: Date, endDate?: Date) {
      return http.post(this.passenger_authorizations + '/list', { startDate, endDate }, this.config)
    }

    approvePassengerAuthorization(id: string) {
      return http.post(this.passenger_authorizations + `/approve/${id}`, {}, this.config)
    }
    
    rejectPassengerAuthorization(id: string) {
      return http.post(this.passenger_authorizations + `/reject/${id}`, {}, this.config)
    }
}

const AdminService = new AdminServiceClass()

export default AdminService;